<template>
  <div class="field">
    <div class="label">
      {{ label }}
    </div>
    <input 
      :type="type"
      class="control"
      :class="{ 'disabled': disabled, 'total': color === 'total',}" 
      :disabled="disabled"
      :value="value"
      @input="$emit('input', $event.target.value)"
    />
  </div>
</template>

<script>
export default {
  name: "FixedPanelField",
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      required: true
    },
    color: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.field {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0.25rem;
}

.label {
  color: white;
  white-space: nowrap;
  text-align: center;
}

.control {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  background: white;
  color: #545454;
  border: 1px solid #1976d2;
  text-align: center;
  height: 2rem;
  border-radius: 20px;
  width: 100%;
}

.value.disabled {
  background: #d6eaf3;
}

.control.total {
  font-size: 1.3rem;
  background-color: #00a178;
  color: white;
  font-weight: bold;
}
</style>